export default condition => (condition === true ? 'Sim' : 'Não')
